import "./footer.css";

function Footer() {
  const currentYear = new Date().getFullYear();
  return (
    <>
      <style>{`
        @media (max-width: 768px) {
          .footer-area {
            padding-top: 40px !important;
            padding-bottom: 40px !important;
          }
          .footer-logo img {
            max-width: 120px !important;
            width: 100% !important;
            height: auto !important;
          }
          .footer-widget {
            margin-left: 0 !important;
            margin-bottom: 30px !important;
            text-align: center !important;
          }
          .footer-title h3 {
            font-size: 16px !important;
            margin-bottom: 12px !important;
          }
          .footer-list ul {
            padding-left: 0 !important;
            list-style: none !important;
          }
          .footer-list li {
            margin-bottom: 8px !important;
          }
          .copyright {
            text-align: center !important;
            margin-bottom: 30px !important;
          }
          .copyright p {
            font-size: 14px !important;
            margin-top: 12px !important;
          }
        }
      `}</style>
      <footer className="footer-area bg-gray pt-100 pb-70">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-6 col-sm-6">
              <div className="copyright mb-30">
                <div className="footer-logo">
                  <a href="/">
                     <img alt="" src="/assets/img/logo/logo-4.png" style={{ maxWidth:"150px", width:"100%", height:"auto", objectFit:"contain"}} />
                </a>
                </div>
                <p>
                  © {currentYear} <a href="/">EventNova</a>.<br /> All Rights
                  Reserved
                </p>
              </div>
            </div>
            <div className="col-lg-2 col-md-6 col-sm-6">
              <div className="footer-widget mb-30">
                <div className="footer-title">
                  <h3>ABOUT US</h3>
                </div>
                <div className="footer-list">
                  <ul>
                    <li>
                      <a href="/about">About us</a>
                    </li>
                    <li>
                      <a href="/contact">Contact</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-2 col-md-6 col-sm-6">
              <div className="footer-widget mb-30">
                <div className="footer-title">
                  <h3>USEFUL LINKS</h3>
                </div>
                <div className="footer-list">
                  <ul>
                    <li>
                      <a href="/vendors">Vendors</a>
                    </li>
                    
                    <li>
                      <a href="/contact">Support</a>
                    </li>
                    <li>
                      <a href="/contact">FAQs</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-2 col-md-6 col-sm-6">
              <div className="footer-widget mb-30">
                <div className="footer-title">
                  <h3>LEGAL & POLICY</h3>
                </div>
                <div className="footer-list">
                  <ul>
                    <li>
                      <a href="/privacy-policy">Privacy Policy</a>
                    </li>
                    <li>
                      <a href="/terms">Terms & Conditions</a>
                    </li>
                    <li>
                      <a href="/refund-policy">Refund Policy</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-2 col-md-6 col-sm-6">
              <div className="footer-widget mb-30">
                <div className="footer-title">
                  <h3>FOLLOW US</h3>
                </div>
                <div className="footer-list">
                  <ul>
                    <li>
                      <a
                        href="https://www.facebook.com"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Facebook
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.twitter.com"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Twitter
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.instagram.com"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Instagram
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.youtube.com"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Youtube
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
